// getInnerWidth - Used for get the content width of the element except padding.
const getInnerWidth = (el) => {
    /* istanbul ignore if -- @preserve */
    if (!el)
        return 0;
    const { clientWidth } = el;
    const { paddingLeft, paddingRight } = getComputedStyle(el);
    return clientWidth - parseFloat(paddingLeft) - parseFloat(paddingRight);
};
// getInnerHeight - Used for get the content height of the element except padding.
const getInnerHeight = (el) => {
    /* istanbul ignore if -- @preserve */
    if (!el)
        return 0;
    const { clientHeight } = el;
    const { paddingTop, paddingBottom } = getComputedStyle(el);
    const h = clientHeight - parseFloat(paddingTop) - parseFloat(paddingBottom);
    return h;
};
// getThumbHorizontalWidth - Used for get the thumb width of the horizontal scrollbar.
const getThumbHorizontalWidth = (containerView, trackHorizontal) => {
    /* istanbul ignore if -- @preserve */
    if (!containerView)
        return 0;
    const { scrollWidth, clientWidth } = containerView;
    const trackWidth = getInnerWidth(trackHorizontal) || clientWidth;
    const thumbwidth = Math.ceil((trackWidth / scrollWidth) * trackWidth);
    /* istanbul ignore if -- @preserve */
    if (trackWidth === thumbwidth)
        return 0;
    return Math.max(thumbwidth);
};
// getThumbVerticalHeight - Used for get the thumb height of the vertical scrollbar.
const getThumbVerticalHeight = (containerView, trackVertical) => {
    /* istanbul ignore if -- @preserve */
    if (!containerView)
        return 0;
    const { scrollHeight, clientHeight } = containerView;
    const trackHeight = getInnerHeight(trackVertical) || clientHeight;
    const thumbheight = Math.ceil((trackHeight / scrollHeight) * trackHeight);
    /* istanbul ignore if -- @preserve */
    if (trackHeight === thumbheight)
        return 0;
    return thumbheight > 32 ? Math.max(thumbheight) : 32;
};
// getScrollLeftForOffset - Used for get the scroll left offset
const getScrollLeftForOffset = (offset, containerView, trackHorizontal) => {
    const { scrollWidth, clientWidth } = containerView;
    const trackWidth = getInnerWidth(trackHorizontal);
    return ((offset /
        (trackWidth - getThumbHorizontalWidth(containerView, trackHorizontal))) *
        (scrollWidth - clientWidth));
};
// getScrollTopForOffset - Used for get the scroll top offset
const getScrollTopForOffset = (offset, containerView, trackVertical) => {
    const { scrollHeight, clientHeight } = containerView;
    return ((offset /
        (getInnerHeight(trackVertical) -
            getThumbVerticalHeight(containerView, trackVertical))) *
        (scrollHeight - clientHeight));
};
const _onHorizontalTrackMouseDown = (event, containerView, trackHorizontal) => {
    if (event === null || event === void 0 ? void 0 : event.preventDefault) {
        event.preventDefault();
    }
    const { clientX } = event;
    const target = event.target;
    const { left: targetLeft } = target.getBoundingClientRect();
    const offset = Math.abs(targetLeft - clientX) -
        getThumbHorizontalWidth(containerView, trackHorizontal) / 2;
    const left = getScrollLeftForOffset(offset, containerView, trackHorizontal);
    // eslint-disable-next-line no-param-reassign
    containerView.scrollLeft = left;
};
const _onVerticalTrackMouseDown = (event, containerView, trackVertical) => {
    if (event === null || event === void 0 ? void 0 : event.preventDefault) {
        event.preventDefault();
    }
    const { clientY } = event;
    const target = event.target;
    const { top: targetTop } = target.getBoundingClientRect();
    const offset = Math.abs(targetTop - clientY) -
        getThumbVerticalHeight(containerView, trackVertical) / 2;
    const top = getScrollTopForOffset(offset, containerView, trackVertical);
    // eslint-disable-next-line no-param-reassign
    containerView.scrollTop = top;
};

export { _onHorizontalTrackMouseDown, _onVerticalTrackMouseDown, getInnerHeight, getInnerWidth, getScrollLeftForOffset, getScrollTopForOffset, getThumbHorizontalWidth, getThumbVerticalHeight };
